module.exports = __webpack_public_path__ + "static/full04-f3369717a39cbfe0ab9baecf7d28fe40.png";